export class Logger {
  _log: boolean = false;
  _logger: string = '';

  constructor(active: boolean, logger: string) {
    this._log = active;
    this._logger = logger;
  }

  trace(text: any) {
    if (!this._log) return;
      const content = `[${this._logger}] ${text}`;
      console.trace(content);
  }

  info(text: any) {
    if (!this._log) return;
      const content = `[${this._logger}] ${text}`;
      console.log(content);
  }

  error(text: any) {
    if (!this._log) return;
      const content = `[${this._logger}] ${text}`;
      console.error(content);
  }
}
export type CmsButtonLayout =
  | 'default'
  | 'highlight'
  | 'grey'
  | 'white'
  | 'redrat'
  | 'red'
  | 'red-red'
  | 'red-green'
  | 'green'
  | 'custom-color'
  | 'form-submit'

export interface CmsButtonConfig {
  name?: string;
  form?: string;
  label?: string;
  layout?: CmsButtonLayout;
  fontColor?: string; // class: color-light | btn-font-color-light | color-dark | btn-font-color-dark
  icon?: string;
  iconPosition?: HorizontalPosition;
  bgColor?: string;
  width?: string;
  noMargin?: boolean;
}

export interface CmsLinkConfig {
  link?: string;
  target: string | '_self';
  label?: string;
  description?: string;
  sectionId?: string;
  gtmId?: string;
  class?: string;
  dam: boolean | false;
  selected: boolean | false;
  children?: [];
  button?: CmsButtonConfig;
  image?: CmsImageConfig;
}

export interface CmsImageConfig {
  "url": string;
  "caption": string;
  "width": number;
  "height": number;
}

export interface Behavior {
  sticky: boolean;
  hideUnderlying: boolean;
  fullVirtualHeight: boolean;
  backgroundColor: string;
  backgroundOpacity: number;
  renderMarginDiv: boolean | false;
  blockmargin: BlockMargin;
  collapsePadding: Padding;
  additionalClasses: string[];
  hideInViewport: Viewport;
}

export interface SectionBehavior {
  sticky: boolean;
  fullVirtualHeight: boolean;
  bgColor: string;
  blockMargin: BlockMargin;
  hostClass: string;
  sectionClass: string;
  sectionStyle: {};
}

export const VIEWPORTS = ['xs', 'sm', 'md', 'lg'];

export interface Viewport {
  xs: boolean,
  sm: boolean,
  md: boolean,
  lg: boolean
}

export interface BlockMargin {
  top: boolean,
  bottom: boolean
}

export interface Padding {
  top: boolean,
  left: boolean,
  right: boolean,
  bottom: boolean
}

export interface Video {
    webm: string;
    mp4: string;
}

export interface Picture {
  src: string;
  alt: string;
}

export type AnimationFunctions =
  | 'linear'
  | 'ease'
  | 'ease-in'
  | 'ease-out'
  | 'ease-in-out';

export type BreakpointSpeedConfig = {
  name: string;
  fromWidth: number;
  speedMultiplier: number;
};

export type AnimationDirection =
  | 'normal'
  | 'reverse';

export const VerticalPositionTop = 'top';
export const VerticalPositionBottom = 'bottom';

export type VerticalPosition =
  | 'top'
  | 'bottom';

export type HorizontalPosition =
  | 'left'
  | 'center'
  | 'right';

export type Position =
  | 'top'
  | 'bottom'
  | 'center'
  | 'left'
  | 'right';

export type AnchorType =
  | 'link'
  | 'inpage';

export type TextPosition =
  | 'top'
  | 'center'
  | 'bottom';

export type FormValue = {
  name: string;
  value: any;
}

export type FilterType =
  | 'country';

export type PaginationType =
  | 'dot'
  | 'number';

export type InputFieldType =
  'text'
  | 'password'
  | 'email'
  | 'tel'
  | 'dropdown'
  | 'checkboxes'
  | 'legend'
  | 'label'
  | 'checkbox'
  | 'button'
  | 'submit'
  | 'placeholder'
  | 'link'
  | 'hidden';
